import axios from "axios";

const normalizedEnvBackend = (process.env.REACT_APP_BACKEND_URL || "")
    .trim()
    .replace(/\/+$/, "");
const runtimeOrigin =
    typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = normalizedEnvBackend || runtimeOrigin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) =>
                e && typeof e.msg === "string" ? e.msg : JSON.stringify(e),
            )
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
